import styled from "styled-components/macro";

import {
  SectionContent,
  WrapperVerticalPadding,
  sidePadding,
} from "Payments/PaymentPage/PaymentFormScreen/styles";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { AnimatePresence, motion } from "framer-motion";

import { usePaymentForm } from "../PaymentFormContext";

import AuthIcon from "./AuthIcon";
import CurrentUser from "./CurrentUser";
import LoginForm from "./LoginForm";
import Untouched from "./Untouched";
import usePrefectTwoFA from "./usePrefetchTwoFA";

export default function AuthSection() {
  const {
    state: { formStages },
  } = usePaymentForm();

  const {
    state: { paymentParent },
  } = usePaymentPage();

  const renderContent = () => {
    if (
      formStages.auth === "isFullyLoggedIn" ||
      formStages.auth === "skipped"
    ) {
      return <CurrentUser key="current_user" />;
    } else if (
      formStages.auth === "untouched" &&
      formStages.amount !== "complete"
    ) {
      return <Untouched key="untouched" />;
    } else {
      return <LoginForm key="login_form" />;
    }
  };

  // prefetch this endpoint
  usePrefectTwoFA();
  if (paymentParent?.hideAuth) return null;

  return (
    <Wrapper>
      <AuthSectionContent>
        <AuthIcon />
        <ContentInside>
          <AnimatePresence>{renderContent()}</AnimatePresence>
        </ContentInside>
      </AuthSectionContent>
      <WrapperVerticalPadding />
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  ${sidePadding}
`;
const AuthSectionContent = styled(SectionContent)`
  padding: 0;
  overflow: visible;
`;
const ContentInside = styled.div`
  position: relative;
  flex-grow: 1;
`;
